import { Truck, Globe2, Gamepad2, PartyPopper, type LucideIcon } from "lucide-react";

interface AnnouncementItem {
  icon: LucideIcon;
  text: string;
}

const items: AnnouncementItem[] = [
  { icon: Globe2, text: "We deliver all over India for Corporate Events & Bulk Orders" },
  { icon: Truck, text: "Free Delivery & Setup in Pune & Mumbai" },
  { icon: Gamepad2, text: "Meta Quest 3 & Oculus Quest Rentals" },
  { icon: PartyPopper, text: "Perfect for Birthdays, Weddings & College Fests" },
];

const Track = ({ hidden }: { hidden?: boolean }) => (
  <div className="flex shrink-0" aria-hidden={hidden}>
    {items.map(({ icon: Icon, text }, i) => (
      <span
        key={i}
        className="flex items-center gap-2 px-5 text-xs sm:text-sm font-medium text-primary-foreground whitespace-nowrap"
      >
        <Icon className="w-3.5 h-3.5 shrink-0" />
        {text}
        <span className="text-primary-foreground/40 pl-5">•</span>
      </span>
    ))}
  </div>
);

const AnnouncementBar = () => {
  return (
    <div className="fixed top-0 left-0 right-0 z-[60] h-9 overflow-hidden bg-gradient-brand group">
      <div className="flex h-full items-center animate-marquee motion-reduce:animate-none group-hover:[animation-play-state:paused]">
        <Track />
        <Track hidden />
      </div>
    </div>
  );
};

export default AnnouncementBar;
